import React, { useState, useEffect } from 'react';
import { useNotification } from '../../../../hooks/useNotification';
import { useDataAuth } from '../../../../hooks/useDataAuth';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';

import { Dialog } from '../../../others/Dialog';
import { ActionButtons } from '../../../others/ActionButtons';
import { LoadButtons } from '../../../../screens/sharedViews/components/LoadButtons';
import { editContactName } from '../../../../services/whatsApp.service';

export const HeaderChat = ({ setUsers, setChatSelected, chatSelected, singleChatMode, goBack, configuration }) => {

    const [sendNotification] = useNotification();
    const [{ userSession }] = useDataAuth();
    const [anchorEl, setAnchorEl] = useState(null);
    const [openEdit, setOpenEdit] = useState(false);
    const [editedName, setEditedName] = useState(chatSelected.name);

    const handleBack = () => setChatSelected(null);
    const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
    const handleMenuClose = () => setAnchorEl(null);

    const handleOpenEdit = () => {
      handleMenuClose();
      setOpenEdit(true);
    };

    const handleEditSave = () => {
        editContactName(userSession.token, { id_marketing_whatsapp: chatSelected.id_marketing_whatsapp, name: editedName });
        setChatSelected((prev) => ({ ...prev, name: editedName }));
        setUsers(prev => {
          return prev.map(user =>
              user.id_marketing_whatsapp === chatSelected.id_marketing_whatsapp
                ? { ...user, name: editedName }
                : user
            );
        });

        setOpenEdit(false);
        setEditedName('');
        sendNotification({
            msg: 'Nombre del contacto actualizado correctamente',
            variant: 'success',
        });
    };

    useEffect(() => {
        setEditedName(chatSelected.name);
    }, [chatSelected, userSession.token]);

    const handleEditCancel = () => {
        setEditedName('');
        setOpenEdit(false);
    };

  return (
    <Box
      sx={{
        // paddingTop: '55px',
        marginTop: '48px',
        // height: '60px',
        height: '70px',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '#202c33',
        borderBottom: '1px solid #2a3942',
        justifyContent: 'space-between'
      }}
    >
      <Box display="flex" alignItems="center">
        <IconButton onClick={ !singleChatMode ? handleBack : goBack }>
          <ArrowBackIcon sx={{ color: 'white' }} />
        </IconButton>
        <Avatar src="" sx={{ mx: 2 }} />
        <Typography variant="subtitle1" color="white">
          {chatSelected.name}
        </Typography>
      </Box>


      <Box display="flex" alignItems="right" sx={{ px: 1 }}>
      {configuration && (
        
          <LoadButtons
            data={{
              configuration: typeof configuration === 'string' ? configuration : JSON.stringify(configuration),
              id: chatSelected.id_marketing_whatsapp,
            }}
            handleChange={() => {}}
            isMobileScreen={false}
          />
        
      )}

      {/* <IconButton onClick={handleMenuOpen}>
        <MoreVertIcon sx={{ color: 'white' }} />
      </IconButton>

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
        <MenuItem onClick={handleOpenEdit}>Editar contacto</MenuItem>
      </Menu> */}

      {/* IN configuration you receive something like:

      {"flow_process":[{"accion":"Personalizar aqui","type":"Redirect","icon":"WhatsApp","color":"gray","config":{"path":"/whatsApp"}}]}
      
      */}

      <Dialog
        openDialog={openEdit}
        title="Editar contacto"
        styleTitle={{ fontWeight: 'bold', color: 'white' }}
        styleDialog={{ backgroundColor: '#111b21', color: 'white' }}
        content={
          <Stack spacing={2} mt={1}>
            <TextField
              placeholder="Nombre"
              variant="outlined"
              fullWidth
              value={editedName}
              onChange={(e) => setEditedName(e.target.value)}
              sx={{ border: '1px solid #4b5563' }}
              InputProps={{
                style: { color: 'white' },
              }}
            />
          </Stack>
        }
        actions={
          <ActionButtons
            onCancel={handleEditCancel}
            onSubmit={handleEditSave}
            submitLabel="Guardar"
          />
        }
        styleActions={{ margin: '10px 16px' }}
      />

      </Box>
      
    </Box>
  );
};
